document.addEventListener("DOMContentLoaded", function () {
  // Header sticky
  $(window).scroll(function () {
    if ($(this).scrollTop() > 40) {
      $(".ctm_header_wrapper").addClass("menufixed");
      $("body").addClass("header-fixed");
      $("body").addClass("cart-top");
    } else {
      $(".ctm_header_wrapper").removeClass("menufixed");
      $("body").removeClass("header-fixed");
      $("body").removeClass("cart-top");
    }
  });
  // Header account-popup
  $(".login_popup").click(function () {
    if ($(this).hasClass("active")) {
      // If the login popup is already active, we should close it
      $(this).removeClass("active");
      $(".customer-account").addClass("hidden");
      $(".customer-account").removeClass("login-left");
      $("body").removeClass("overflow-hidden");
      $("#shopify-section-account-popup").hide();
      $(".ctm-login-modal-bg").removeClass("active");
    } else {
      // If the login popup is not active, we should open it
      $(this).addClass("active");
      $(".customer-account").removeClass("hidden");
      $("#shopify-section-account-popup").show();
      $(".ctm-login-modal-bg").addClass("active");
      $(".customer-account").addClass("login-left");
      $("body").addClass("overflow-hidden");
    }
  });

  $(".ctm-login-modal-bg").click(function () {
    $(this).removeClass("active");
    $(".customer-account").addClass("hidden");
    $(".customer-account").removeClass("login-left");
    $(".login_popup").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $("#shopify-section-account-popup").hide();
  });

  $(".header__icon--cart").click(function () {
    $(".c-modal").addClass("hidden").removeClass("login-left");
    $(".login_popup").removeClass("active");
  });

  $("#login-none").click(function () {
    $(".login-cta").addClass("d-none");
    $(".reset-password").removeClass("d-none");
  });
  $("#recover-cancel").click(function () {
    $(".login-cta").removeClass("d-none");
    $(".reset-password").addClass("d-none");
  });

  $("#regi_forgot_pass").click(function () {
    $("#img-1").removeClass("current");
    $("#tab-1").removeClass("current");
    $("#login").removeClass("current");
    $("#img-2").addClass("current");
    $("#tab-2").addClass("current");
    $("#signup").addClass("current");
  });
  $("#regi-recover-cancel").click(function () {
    $(".reset-password").addClass("d-none");
    $(".forgot-block-area").removeClass("d-none");
  });

  $(".tab-heading ul li a").click(function () {
    var tab_idd = $(this).attr("data-tab");
    var tab_img = $(this).attr("data-img");

    $(".reset-password").addClass("d-none");
    $(".login-cta").removeClass("d-none");
    $(".forgot-block-area").removeClass("d-none");

    $(".tab-heading ul li a").removeClass("current");
    $(".account-tab.tab-pane").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_idd).addClass("current");
    $("#" + tab_img).addClass("current");
  });

  // Check if the element with class 'ctm_global_banner' is not present
  if (!$(".ctm_global_banner").length) {
    // Add the class 'header_relative' to the element with class 'ctm_header_wrapper'
    $(".ctm_header_wrapper").addClass("header_relative");
  }

  // PDP Tabs
  const tabs = document.querySelectorAll(".navtab");
  const contents = document.querySelectorAll(".ctm_pdp_tab_content");
  const underline = document.querySelector(".underline");

  function updateUnderline() {
    const activeTab = document.querySelector(".navtab.active");
    if (activeTab) {
      underline.style.width = `${activeTab.offsetWidth}px`;
      underline.style.left = `${activeTab.offsetLeft}px`;
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");
      const target = tab.getAttribute("data-target");
      contents.forEach((content) => {
        if (content.id === target) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });
      updateUnderline();
    });
  });

  // Load More In Collection

  $(".ctm_productgrid_list").hide();
  $(".ctm_productgrid_list").slice(0, 12).show();

  function toggleLoadMoreButton() {
    const totalItems = $(".ctm_productgrid_list").length;
    const hiddenItems = $(".ctm_productgrid_list:hidden").length;

    if (totalItems <= 8 || hiddenItems === 0) {
      $(".blog-loadmore-btn").hide();
    } else {
      $(".blog-loadmore-btn").show();
    }
  }

  toggleLoadMoreButton();

  $("body").on("click touchstart", "#load-more", function (e) {
    e.preventDefault();
    $(".ctm_productgrid_list:hidden").slice(0, 4).slideDown();
    toggleLoadMoreButton();
  });

  // hero slider
  var swiper = new Swiper(".heroslider", {
    slidesPerView: 1,
    effect: "fade",
    speed: 1000,
    navigation: {
      nextEl: ".next-btn",
      prevEl: ".prev-btn",
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });

  // snack slider
  var swiper = new Swiper(".snackslider", {
    slidesPerView: 1.4,
    speed: 2000,
    spaceBetween: 10,
    centeredSlides: false,
    navigation: {
      nextEl: ".next-btn",
      prevEl: ".prev-btn",
    },
    breakpoints: {
      0: {
        centeredSlides: true,
        loop: true,
        slidesPerView: 1.2,
      },
      1024: {
        centeredSlides: false,
        loop: false,
        slidesPerView: 1.4,
      },
    },
  });

  // $(document).ready(function () {
  //   function AddReadMore() {
  //     var carLmt = 200;
  //     var readMoreTxt = " ...read more";
  //     var readLessTxt = " read less";

  //     $(".add-read-more").each(function () {
  //       if ($(this).find(".first-section").length) return;

  //       var allstr = $(this).html();
  //       if (allstr.length > carLmt) {
  //         var firstSet = allstr.substring(0, carLmt);
  //         var secdHalf = allstr.substring(carLmt);

  //         var strtoadd = `
  //                   ${firstSet}
  //                   <span class='second-section'>${secdHalf}</span>
  //                   <span class='read-more' title='Click to Show More'>${readMoreTxt}</span>
  //                   <span class='read-less' title='Click to Show Less'>${readLessTxt}</span>
  //               `;
  //         $(this).html(strtoadd);
  //       }
  //     });
  //     $(document).on("click", ".read-more, .read-less", function () {
  //       $(this)
  //         .closest(".add-read-more")
  //         .toggleClass("show-less-content show-more-content");
  //     });
  //   }

  //   AddReadMore();
  // });

  // product slider

  $(document).ready(function () {
    var swiper2 = new Swiper(".ctm_pdp_mainproduct_thumbnail_slider", {
      loop: true,
      spaceBetween: 14,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper = new Swiper(".ctm_pdp_mainproduct_slider", {
      slidesPerView: 1,
      grabCursor: true,
      draggable: true,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper2,
      },
    });
  });

  // blog search

  $(document).on("input", "#blog_search_bar", function () {
    var searchTerm = $(this).val();
    $("#search_input").text(searchTerm);
    blogSearch(searchTerm);
    checkPagination(); // Check pagination after the search is performed
    checkInput();
  });

  var clearIcon = $(".clear-icon");
  var searchBar = $("#blog_search_bar");

  function blogSearch(searchBlog) {
    var blogContent = $(".blog-articles__article");

    blogContent.each(function () {
      var panelContainerId = $(this);
      var blogHTML = panelContainerId.text().toLowerCase();

      if (blogHTML.includes(searchBlog.toLowerCase())) {
        panelContainerId.show().removeClass("hidden");
      } else {
        panelContainerId.hide().addClass("hidden");
      }
    });

    // Check if any blogs are visible and show "no data" message if none are visible
    var hiddenBlogCount = blogContent.filter(".hidden").length;
    var visibleBlogCount = blogContent.length - hiddenBlogCount;

    if (visibleBlogCount === 0) {
      $(".no_datas").removeClass("hidden"); // Show 'no data' message if no matches
    } else {
      $(".no_datas").addClass("hidden"); // Hide 'no data' message if there are matches
    }

    // Call pagination check after filtering the articles
    checkPagination(visibleBlogCount);
  }

  // Function to check and show/hide pagination based on the visible results
  function checkPagination(visibleBlogsCount) {
    // Show/Hide pagination based on the count of visible results
    if (visibleBlogsCount > 12) {
      $(".pagination").removeClass("hidden");
    } else {
      $(".pagination").addClass("hidden");
    }
  }

  function checkInput() {
    if (searchBar.val().length) {
      clearIcon.removeClass("hidden");
    } else {
      clearIcon.addClass("hidden");
    }
  }

  clearIcon.click(function () {
    searchBar.val("");
    searchBar.trigger("input"); // Trigger input event for real-time update
    clearIcon.addClass("hidden");
  });

  // blog filter

  $(function () {
    $("#BlogTagFilter").on("change", function () {
      var url = $(this).val();
      if (url) {
        window.location = url;
      }
      return false;
    });
  });

  // FAQ for PDP
  document
    .querySelectorAll(".ctm_faq_title_inner, .ctm-main-faq")
    .forEach((section) => {
      let questions = section.querySelectorAll(".faq_question");
      let previousActiveQuestion = null;

      questions.forEach((question) => {
        let icon = question.querySelector(".icon-shape");

        question.addEventListener("click", (event) => {
          if (previousActiveQuestion && previousActiveQuestion !== question) {
            previousActiveQuestion.classList.remove("active");
            previousActiveQuestion
              .querySelector(".icon-shape")
              .classList.remove("active");
            previousActiveQuestion.nextElementSibling.style.maxHeight = 0;
          }

          question.classList.toggle("active");
          icon.classList.toggle("active");

          const answer = question.nextElementSibling;

          if (question.classList.contains("active")) {
            answer.style.maxHeight = answer.scrollHeight + "px";
            previousActiveQuestion = question; // Update the previously active question
          } else {
            answer.style.maxHeight = 0;
            previousActiveQuestion = null; // No question is active now
          }
        });

        // Check if the question has the "open" class and add the "active" class accordingly
        if (question.classList.contains("open")) {
          question.classList.add("active");
          icon.classList.add("active");
          const answer = question.nextElementSibling;
          answer.style.maxHeight = answer.scrollHeight + "px";
          previousActiveQuestion = question; // Set the initially active question
        }
      });
    });

  //Collection Page Filter
  const filterCheckboxes = document.querySelectorAll(
    '.facets__item input[type="checkbox"]'
  );
  const removeAllButton = document.querySelector(
    ".active-facets__button-remove"
  );
  const facetRemoveLinks = document.querySelectorAll("facet-remove a");
  const closeIcons = document.querySelectorAll(
    ".svg-wrapper .icon-close-small"
  );
  filterCheckboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", function () {
      const currentUrl = new URL(window.location);
      const filterName = checkbox.name;
      const filterValue = checkbox.value;
      let params = new URLSearchParams(currentUrl.search);
      if (checkbox.checked) {
        params.append(filterName, filterValue);
      } else {
        params.delete(filterName);
      }
      currentUrl.search = params.toString();
      window.location.href = currentUrl.toString();
    });
  });
  if (removeAllButton) {
    removeAllButton.addEventListener("click", function (event) {
      event.preventDefault();
      const removeAllUrl = removeAllButton.getAttribute("href");
      window.location.href = removeAllUrl;
    });
  }
  facetRemoveLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const removeUrl = link.getAttribute("href");
      window.location.href = removeUrl;
    });
  });
});

const hideCart = document.querySelector(".ctm_cart_yml_hide");

if (hideCart) {
  hideCart.addEventListener("click", function () {
    document.querySelector(".cart_related_product").classList.add("remove");
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;
  if (
    currentUrl === "https://snacksafari.com/pages/snack-subscription" ||
    currentUrl.startsWith("https://snacksafari.com/pages/snack-subscription?")
  ) {
    window.location.href =
      "https://snacksafari.com/products/snack-the-whole-year";
  }

  function updatePrice() {
    const activeRadio = document.querySelector(".rc-radio.rc-radio--active");
    if (activeRadio) {
      const priceLabel = activeRadio.querySelector(".price-label");
      if (priceLabel) {
        const dynamicPriceSpans =
          document.querySelectorAll(".ctm-price-dynamic");
        dynamicPriceSpans.forEach((span) => {
          span.textContent = priceLabel.textContent.trim();
        });
      }
    }
  }

  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("rc-radio__input")) {
      updatePrice();
    }
  });

  function waitForRender() {
    if (document.querySelector(".rc-radio.rc-radio--active")) {
      updatePrice();
    } else {
      requestAnimationFrame(waitForRender);
    }
  }
  waitForRender();

  const stickyQuantityInput = document.querySelector(".sticky-input");
  if (stickyQuantityInput) {
    stickyQuantityInput.addEventListener("input", function () {
      const quantityInput = document.querySelector(
        ".product__info-wrapper .quantity__input"
      );
      if (quantityInput) {
        quantityInput.value = this.value;
        quantityInput.dispatchEvent(new Event("change"));
      }
    });
  }

  const stickyAddToCartButton = document.querySelector(".sticky-add-to-cart");
  const productFormSubmitButton = document.querySelector(
    ".product__info-wrapper .product-form__submit"
  );

  if (stickyAddToCartButton && productFormSubmitButton && stickyQuantityInput) {
    stickyAddToCartButton.addEventListener("click", function () {
      productFormSubmitButton.click();
      stickyQuantityInput.value = 1;
    });
  }

  const stickyPlusButton = document.querySelector(
    ".sticky-quantity-input .plus-button"
  );
  const stickyMinusButton = document.querySelector(
    ".sticky-quantity-input .minus-button"
  );
  const productFormMinusButton = document.querySelector(
    ".product__info-wrapper .minus-button"
  );
  const productFormPlusButton = document.querySelector(
    ".product__info-wrapper .plus-button"
  );

  if (stickyPlusButton && productFormPlusButton) {
    stickyPlusButton.addEventListener("click", function () {
      productFormPlusButton.click();
    });
  }

  if (stickyMinusButton && productFormMinusButton) {
    stickyMinusButton.addEventListener("click", function () {
      productFormMinusButton.click();
    });
  }
});
